import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LiftUpContainer from "../components/container/LiftUpContainer";
import Navbar from "../layout/Navbar";
import Sidebar from "../layout/Sidebar";
import ComingSoon from "../pages/ComingSoon";
import Explore from "../pages/Explore";
import MainPlayer from "../layout/MainPlayer";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import {
  setmaxRange,
  setrange,
  setplay,
  setloaded,
  setonChangeLoaded,
  playNewSong,
  setcurrentSongIndex,
} from "../redux/actions/player";
import { mainPlayerToggle, volumeToggle } from "../redux/actions/styles";
import Genres from "../pages/Genres";
import Albums from "../pages/Albums";
import Volume from "../layout/Volume";
import ScrollToTop from "./ScrollToTop";
import ArtistPage from "../pages/ArtistPage";
import CreatePlaylist from "../pages/CreatePlaylist";
import Playlist from "../pages/Playlist";
import PlaylistPopup from "../layout/PlaylistPopup";
import Notification from "../components/Notification";
import SearchPage from "../pages/Search";
import Snap from "../pages/Snap";

const PageRoutes = () => {
  const { mainPlayerOpen } = useSelector((state) => state.styles);
  const [liftUpActive, setliftUpActive] = useState(false);

  const dispatch = useDispatch();
  const AC = bindActionCreators(
    { setmaxRange, setrange, setplay, setloaded, setonChangeLoaded, mainPlayerToggle, volumeToggle },
    dispatch
  );
  const {
    currentSong: { audio, color },
    maxRange,
    range,
    play,
    loaded,
    onChangeLoaded,
    volume,
    currentSongIndex,
    currentSongList,
  } = useSelector((state) => state.player);

  const initialRenderRef = useRef(true);
  let audioRef = useRef(new Audio(audio));

  useEffect(() => {
    return () => {
      audioRef.current.pause();
    };
  }, []);

  useEffect(() => {
    AC.setloaded(false);
    if (initialRenderRef.current) {
      initialRenderRef.current = false;
      audioRef.current.oncanplay = function () {
        AC.setonChangeLoaded(true);
      };
    } else {
      audioRef.current.currentTime = 0;
      audioRef.current.pause();
      AC.setrange(0);
      audioRef.current = new Audio(audio);

      // audioRef.current.readyState
      // audioRef.current.oncanplaythrough
      const root = document.querySelector(":root");
      color && root.style.setProperty("--color-music", color);

      audioRef.current.oncanplay = function () {
        audioRef.current.volume = volume;
        AC.setonChangeLoaded(true);
        playSong();
      };

      audioRef.current.onwaiting = function () {
        console.log("buffering");
        // AC.setloaded(false);
      };
      // audioRef.current.ontimeupdate = function () {
      //   AC.setrange(Math.floor(audioRef.current.currentTime));
      //   console.log("time", audioRef.current.currentTime, audioRef.current.duration);
      // };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audio]);

  // useEffect(() => {
  //   if (Number(range) === Number(maxRange)) {
  //     AC.setrange(0);
  //     audioRef.current.currentTime = 0;
  //   }
  //   let rangeInterval;
  //   if (play && loaded && onChangeLoaded) {
  //     rangeInterval = setTimeout(() => {
  //       AC.setrange(Number(range) + 1);
  //     }, 1000);
  //   }

  //   return () => {
  //     clearTimeout(rangeInterval);
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [range, play, loaded, onChangeLoaded]);

  useEffect(() => {
    audioRef.current.onloadedmetadata = function () {
      AC.setloaded(true);
      AC.setmaxRange(Math.floor(audioRef.current.duration));
    };
    // audioRef.current.ontimeupdate = function () {
    //   AC.setrange(Math.floor(audioRef.current.currentTime));
    // };

    audioRef.current.onended = function () {
      onClickNext();
    };

    const interval = setInterval(() => {
      AC.setrange(Math.round(audioRef.current.currentTime));
    }, 1000);

    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audio]);

  useEffect(() => {
    if (play) {
      audioRef.current.play();
    } else {
      audioRef.current.pause();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [play, audio]);

  function playSong() {
    AC.setplay(true);
  }
  function pauseSong() {
    AC.setplay(false);
  }

  function onChangeRange(e) {
    AC.setonChangeLoaded(false);
    AC.setrange(e.target.value);
    audioRef.current.currentTime = Number(e.target.value);
  }

  function toggleVolume() {
    AC.volumeToggle(true);
  }
  useEffect(() => {
    audioRef.current.volume = volume;
  }, [volume]);

  //   useEffect(() => {
  //     function contextMenu(e) {
  //   e.preventDefault();
  //     }
  //     document.addEventListener("contextmenu",contextMenu);
  // return () => document.removeEventListener("contextmenu", contextMenu)
  //   }, [])

  function onClickNext() {
    const song =
      currentSongIndex === currentSongList.length - 1 ? currentSongList[0] : currentSongList[currentSongIndex + 1];
    dispatch(playNewSong(song));
    dispatch(setplay(true));
    currentSongIndex === currentSongList.length - 1
      ? dispatch(setcurrentSongIndex(0))
      : dispatch(setcurrentSongIndex(currentSongIndex + 1));
  }
  function onClickPrev() {
    const song =
      currentSongIndex === 0 ? currentSongList[currentSongList.length - 1] : currentSongList[currentSongIndex - 1];
    dispatch(playNewSong(song));
    dispatch(setplay(true));
    currentSongIndex === 0
      ? dispatch(setcurrentSongIndex(currentSongList.length - 1))
      : dispatch(setcurrentSongIndex(currentSongIndex - 1));
  }

  return (
    <BrowserRouter>
      <ScrollToTop>
        <MainPlayer
          playSong={playSong}
          pauseSong={pauseSong}
          onChangeRange={onChangeRange}
          onClickPrev={onClickPrev}
          onClickNext={onClickNext}
        />
        <Navbar setliftUpActive={setliftUpActive} />
        <Sidebar />

        <LiftUpContainer isActive={liftUpActive} setisActive={setliftUpActive}>
          Coming Soon
        </LiftUpContainer>

        <Volume />
        <PlaylistPopup />
        <Notification />

        <div className={`main ${mainPlayerOpen ? "main-translate" : ""}`}>
          <Routes>
            <Route
              exact
              path="/snap"
              element={
                <Snap
                  playSong={playSong}
                  pauseSong={pauseSong}
                  onChangeRange={onChangeRange}
                  toggleVolume={toggleVolume}
                  onClickPrev={onClickPrev}
                  onClickNext={onClickNext}
                />
              }
            />
            <Route
              exact
              path="/"
              element={
                <Explore
                  playSong={playSong}
                  pauseSong={pauseSong}
                  onChangeRange={onChangeRange}
                  toggleVolume={toggleVolume}
                  onClickPrev={onClickPrev}
                  onClickNext={onClickNext}
                />
              }
            />
            <Route exact path="/genres" element={<Genres />} />
            <Route exact path="/albums" element={<Albums />} />
            <Route exact path="/artists/:artist" element={<ArtistPage />} />
            <Route exact path="/createplaylist" element={<CreatePlaylist />} />
            <Route exact path="/playlist/:playlistRef" element={<Playlist />} />
            <Route exact path="/search" element={<SearchPage />} />
            <Route exact path="/search/:searchText" element={<SearchPage />} />
            <Route exact path="/coming-soon" element={<ComingSoon />} />
          </Routes>
        </div>
      </ScrollToTop>
    </BrowserRouter>
  );
};

export default PageRoutes;
